import { get } from 'services/http';

const getEnvironment = () => get('/environment');

export default { getEnvironment };
